import { useRef } from 'react';
import { Arrows } from '..';
import { dayDiff, diffHours } from '../../../utils';
import { Anchor, Avatar, Content, TaskContainer } from './styles';
import { followCursor } from "tippy.js";
import { TippyContent } from '../TippyContent';
import { StyledTippy } from '../TippyContent/styles';
import Unkown from '../../../../../assets/unkown.png'





export function TaskJob({ job, singleton, theme }) {
  //const taskLength = job.duration;

  const cellWidth = parseInt(theme.cellWidth);
  const ref = useRef();
  const startFrom = new Date(job.start);
  const startTime = startFrom.getHours();
  const leftOffset = (startTime * cellWidth) / 24;
  const today = new Date();
  const endOffset = startFrom.setDate(startFrom.getDate() + job.duration.number / 24)

  const taskLength = job.status === 'late' ?
    dayDiff(job.start, endOffset) : diffHours(job.start, job.end) / 24;

  const finalLength = taskLength > 1 ? taskLength : 1


  const avatar = job.accountable?.avatarURL;
  const diffH = diffHours(today, job.start);




  // Com base no cellWidth -> 60
  return (
    <>
      <TaskContainer

        onClick={() => console.log(job.id)}
        ref={ref}
        status={job.status}
        style={{
          left: leftOffset,
          width:
            job.status === 'late'
              ? (diffH * (cellWidth + 0.13)) / 24 + 'px'
              : null,
          backgroundColor: job.status === 'late' ? '#FFBAAB' : null,
          height: theme.taskStyle.height
        }}
        className="job"
        id={job.id}
      >
        <Content

          status={job.status}
          style={{ width: (finalLength) * cellWidth + 'px' }}
        >

          <Anchor id={'anchor_' + job.id}>

            <Avatar src={avatar ? avatar : Unkown} title={job.accountable?.username} className="avatar" />
          </Anchor>


          <span className="label">{job.label}</span>
        </Content>
        <Arrows job={job} />

      </TaskContainer>
      <StyledTippy content={<TippyContent job={job} />}
        reference={ref}
        singleton={singleton.target} followCursor={true} plugins={[followCursor]}
        duration={200}
        placement="top"
        arrow={true}
        delay={[500, 0]} />
    </>
  );
}
